export const getCookie = (key: string) => {
  const cookieList = document.cookie.split(';');
  const cookies = Object.fromEntries(
    cookieList.map(cookieItem => cookieItem.trim().split(/=(.*)/)),
  );
  if (cookies[key]) {
    return decodeURIComponent(cookies[key]);
  }
  return undefined;
};
